<div *ngIf="isLoader"
  class="w-full justify-center items-center flex flex-col bg-gray-500/10 animate-pulse h-full mt-2 rounded-lg">
  <div class="text-gray-900/60 p-2 text-sm">{{utils.traslatei18n('LOADING')}}</div>
  <div class="uploader-status">
    <mat-spinner [diameter]="30"></mat-spinner>
  </div>

</div>